import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { ExternalLink } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { PageBody } from '../components/layout';
// The support site ships per environment as support.<env>.specra.ai, mirroring
// the app's own agents.<env>.specra.ai host. Derive it from the current origin
// the same way Settings/SSOConfigPage derive the auth host, so a new
// environment needs no build-time env var or deploy wiring. Local dev has no
// support site of its own, so it falls back to staging.
const STAGING_SUPPORT_URL = 'https://support.staging.specra.ai';
const getSupportSiteUrl = ()=>{
    const { hostname, origin } = window.location;
    // Domain-based deployments: agents.<env>.specra.ai → support.<env>.specra.ai
    if (hostname.startsWith('agents.') && hostname.endsWith('.specra.ai')) {
        return origin.replace('agents.', 'support.');
    }
    // Port-based/local deployments have no support site — send them to staging.
    return STAGING_SUPPORT_URL;
};
export default function HelpPage() {
    const supportUrl = getSupportSiteUrl();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Helmet, {
                children: [
                    /*#__PURE__*/ _jsx("title", {
                        children: "Help - Sprezz"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "description",
                        content: "Find answers and get support"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(PageBody, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-4 max-w-xl text-sm text-muted-foreground",
                        children: "Guides, walkthroughs, and answers for Sprezz live on Sprezz Support."
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        asChild: true,
                        children: /*#__PURE__*/ _jsxs("a", {
                            href: supportUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-testid": Testids.help.supportLink,
                            children: [
                                /*#__PURE__*/ _jsx(ExternalLink, {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "Open Sprezz Support"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
